var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnkrbnb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_735_109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.1263 2.09055C56.9982 -0.696849 63.0006 -0.696849 67.8725 2.09055L106.673 24.2896C111.544 27.077 114.546 32.2284 114.546 37.8032V82.2014C114.546 87.7761 111.544 92.9275 106.673 95.7149L67.8725 117.914C63.0006 120.701 56.9982 120.701 52.1263 117.914L13.3262 95.7149C8.45433 92.9275 5.45312 87.7762 5.45312 82.2014V37.8032C5.45312 32.2284 8.45432 27.077 13.3262 24.2896L52.1263 2.09055Z",
    fill: "#FFE81C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.2303 54.3425L60.0014 40.5714L73.7791 54.3484L81.7918 46.3357L60.0014 24.5459L38.2181 46.3292L46.2306 54.3419L46.2303 54.3425ZM24.5469 60.0004L32.5599 51.9863L40.5723 59.9987L32.5593 68.0117L24.5469 60.0004ZM46.2303 65.6593L60.0014 79.4295L73.7788 65.6527L81.7958 73.6612L81.7918 73.6655L60.0014 95.455L38.2181 73.6717L38.2068 73.6604L46.2312 65.6584L46.2303 65.6593ZM79.4305 60.0038L87.4435 51.9908L95.456 60.0033L87.4432 68.0163L79.4305 60.0038Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.1264 59.9959H68.1299L59.9997 51.8652L53.9903 57.8729L53.2999 58.5636L51.8761 59.9877L51.8647 59.9988L51.8761 60.0104L59.9997 68.1352L68.1304 60.0045L68.1344 59.9999L68.127 59.9959",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_735_109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnkrbnb);
export default __webpack_public_path__ + "static/media/ankrbnb.c146f57aeb3b352bf5933ef1bd300e37.svg";
export { ForwardRef as ReactComponent };